import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import { LoadingBar } from 'view-design'
import { GetToken, getRotestList } from '../libs/util'
import { Message } from 'view-design'
// import { getNewTagList, routeEqual, GetToken } from "@/libs/util";
Vue.use(Router)
const router = new Router({
    routes,
    base: process.env.BASE_URL,
    mode: 'hash'
})

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    ;(Message as any).destroy()
    ;(LoadingBar as any).start()
    if (!GetToken().token && to.name !== 'login') {
        next('/login')
    } else {
        if (to.name == 'login' || to.name == 'home' || to.name == 'error_404' || to.name == 'error_401') {
            next()
        } else {
            if (!getRotestList().includes(to.name)) {
                next('/401') // 取消离开
            } else {
                next()
            }
        }
    }
})

router.afterEach((to) => {
    ;(LoadingBar as any).finish()
    window.scrollTo(0, 0)
})
export default router
